import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    // 登录
    {
      path: "/login",
      component(resolve) {
        require(["../pages/Login.vue"], resolve);
      },
    },
    {
      // 忘记密码
      path: "/retrievePassword",
      component(resolve) {
        require(["../pages/retrievePassword.vue"], resolve);
      },
    },
    // 注册
    {
      path: "/registered",
      component(resolve) {
        require(["../pages/Registered.vue"], resolve);
      },
    },
    // 导航栏
    {
      path: "/home/main",
      component(resolve) {
        require(["../pages/Home.vue"], resolve);
      },
      children: [
        {
          //主页
          path: "/home/main",
          name: "main",
          component(resolve) {
            require(["../pages/Main.vue"], resolve);
          },
        },
        //企业信息
        {
          path: "/home/company/CompanyAction",
          name: "Company",
          meta: {
            title: "企业信息",
          },
          component: () => import("../views/account/enterprise/index.vue"),
        },
        //企业管理
        {
          path: "/home/company/companyManagementAction",
          name: "CompanyManagement",
          meta: {
            title: "企业管理",
          },
          component: () => import("../views/account/CompanyManagementAction"),
        },
        {
          path: "/home/account/twoAgentAction",
          name: "twoAgentAction",
          meta: {
            title: "下级代理商",
          },
          component(resolve) {
            require(["../views/account/twoAgent/index.vue"], resolve);
          },
        },
        {
          path: "/home/account/agentAction",
          name: "agent",
          meta: {
            title: "代理商",
          },
          component(resolve) {
            require(["../views/account/agent/agent.vue"], resolve);
          },
        },
        {
          //个人
          path: "/home/account/personageAction",
          name: "personAction",
          meta: {
            title: "个人",
          },
          component(resolve) {
            require(["../views/account/individual/individual.vue"], resolve);
          },
        },
        //子账户
        {
          path: "/home/account/adminAction",
          name: "adminAction",
          meta: {
            title: "子账户",
          },
          component: () => import("@/views/account/adminAction/index"),
        },

        //修改密码
        {
          path: "/home/service/updatepswAction",
          name: "changepassword",
          meta: {
            title: "修改密码",
          },
          component(resolve) {
            require(["../views/systemsettings/changepassword"], resolve);
          },
        },

        //防骚扰清单
        {
          path: "/home/TheHarassment/detailedAccountAction",
          name: "detailedAccountAction",
          meta: {
            title: "防骚扰清单",
          },
          component(resolve) {
            require([
              "../views/reportform/TheHarassment/detailedAccountAction.vue",
            ], resolve);
          },
        },

        {
          //通话详情
          path: "/home/find/RecordListAction",
          name: "RecordListAction",
          meta: {
            title: "通话详情",
          },
          component(resolve) {
            require(["../views/query/RecordListAction.vue"], resolve);
          },
        },
        {
          //通话详情总
          path: "/home/find/RecordListSumAction",
          name: "RecordListSumAction",
          meta: {
            title: "通话详情总",
          },
          component(resolve) {
            require(["../views/query/RecordListSumAction.vue"], resolve);
          },
        },
        {
          //录音清单
          path: "/home/find/callRecordsAction",
          name: "callRecords",
          meta: {
            title: "录音清单",
          },
          component(resolve) {
            require(["../views/query/callRecords.vue"], resolve);
          },
        },
        {
          //坐席查询
          path: "/home/find/setlistAction",
          name: "ZuoxIinquire",
          meta: {
            title: "坐席查询",
          },
          component(resolve) {
            require(["../views/query/ZuoxIinquire.vue"], resolve);
          },
        },

        //代理商授权分配
        {
          path: "/home/Authorized/AgentAuthorizationAction",
          name: "AgentAuthorizationAction",
          meta: {
            title: "代理商授权分配",
          },
          component(resolve) {
            require([
              "../views/account/Authorized/AgentAuthorizationAction.vue",
            ], resolve);
          },
        },
        //企业授权分配
        {
          path: "/home/Authorized/EnterpriseLicenseAction",
          name: "EnterpriseLicenseAction",
          meta: {
            title: "企业授权分配",
          },
          component(resolve) {
            require([
              "../views/account/Authorized/EnterpriseLicenseAction.vue",
            ], resolve);
          },
        },
        //SaaS商授权分配
        {
          path: "/home/Authorized/SaasLicensingDetailsAction",
          name: "SaasLicensingDetailsAction",
          meta: {
            title: "SaaS商授权分配",
          },
          component(resolve) {
            require([
              "../views/account/Authorized/SaasLicensingDetailsAction.vue",
            ], resolve);
          },
        },
        //代理商通信产品分配
        {
          path: "/home/productDistribution/AgentAssignmentAction",
          name: "AgentAssignmentAction",
          meta: {
            title: "代理商通信产品分配",
          },
          component(resolve) {
            require([
              "../views/account/productDistribution/AgentAssignmentAction.vue",
            ], resolve);
          },
        },
        //企业通信产品分配
        {
          path: "/home/productDistribution/DistributionoftheEnterpriseAction",
          name: "DistributionoftheEnterprise",
          meta: {
            title: "企业通信产品分配",
          },
          component(resolve) {
            require([
              "../views/account/productDistribution/DistributionoftheEnterprise.vue",
            ], resolve);
          },
        },
        //通信产品分配详情
        {
          path: "/home/productDistribution/ProductDistributionDetailsAction",
          name: "ProductDistributionDetails",
          meta: {
            title: "通信产品分配详情",
          },
          component(resolve) {
            require([
              "../views/account/productDistribution/ProductDistributionDetails.vue",
            ], resolve);
          },
        },
        //系统管理中的用户
        {
          path: "/home/service/ActionAction",
          name: "systemuser",
          meta: {
            title: "用户",
          },
          component(resolve) {
            require(["../views/systemsettings/systemuser"], resolve);
          },
        },
        //系统管理中的角色与权限
        {
          path: "/home/service/prelistAction",
          name: "rolespermissions",
          meta: {
            title: "角色与权限",
          },
          component(resolve) {
            require(["../views/systemsettings/rolespermissions"], resolve);
          },
        },
        //系统管理中的操作日志
        {
          path: "/home/admin/journalAction",
          name: "operationlog",
          meta: {
            title: "操作日志",
          },
          component(resolve) {
            require(["../views/systemsettings/operationlog"], resolve);
          },
        },
        {
          //APP授权
          path: "/home/account/listAction",
          name: "companyAction",
          meta: {
            title: "APP授权",
          },
          component(resolve) {
            require(["../views/account/AppAuthorization"], resolve);
          },
        },
        //APP授权记录
        {
          path: "/home/account/billAction",
          name: "bill",
          meta: {
            title: "APP授权记录",
          },
          component(resolve) {
            require(["../views/account/AppAuthorization/bill"], resolve);
          },
        },
        //用户授权记录
        {
          path: "/home/account/UserbillAction",
          name: "UserbillAction",
          meta: {
            title: "用户授权记录",
          },
          component(resolve) {
            require(["../views/account/AppAuthorization/Userbill"], resolve);
          },
        },
        {
          path: "/home/system/AuthorizationDetail",
          component: () =>
            import("../views/account/AppAuthorization/Details.vue"),
          name: "AuthorizationDetail",
          meta: {
            title: "派发详情",
          },
        },
        //系统黑名单
        {
          path: "/home/system/BlacklistAction",
          meta: {
            title: "系统黑名单",
          },
          name: "BlacklistAction",
          component: () => import("../views/control/blacklistaction/index.vue"),
        },
        //坐席通话质检
        {
          path: "/home/qualityInspection/restrictIPActionAction",
          meta: {
            title: "坐席通话质检",
          },
          name: "restrictIPActionAction",
          component: () => import("../views/control/qualityInspection"),
        },
        //系统风控规则
        {
          path: "/home/system/RechargeAction",
          meta: {
            title: "系统风控规则",
          },
          name: "SystemRecharge",
          component: () => import("../views/control/systemrecharge/index.vue"),
        },

        {
          path: "/home/account/ElectricPinAction",
          name: "ElectricPinAction",
          meta: {
            title: "电销卡用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/SElectricPinAction",
          name: "SElectricPinAction",
          meta: {
            title: "蓝猫智能电销卡用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/HDSXXCardAction",
          name: "HDSXXCardAction",
          meta: {
            title: "红豆智能电销卡用户",
          },
          component: () => import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/CallTransCardAction",
          name: "CallTransCard",
          meta: {
            title: "呼转卡用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/QtySmallCardAction",
          name: "QtySmallCard",
          meta: {
            title: "话机小号B用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/HuaweiSmallCardAction",
          name: "HuaweiSmallCard",
          meta: {
            title: "话机小号A用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/SinglecardAAction",
          name: "SinglecardA",
          meta: {
            title: "单卡话机小号A用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/SinglecardCAction",
          name: "SinglecardC",
          meta: {
            title: "单卡话机小号C用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/SinglecardDAction",
          name: "SinglecardD",
          meta: {
            title: "单卡话机小号D用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/SinglecardEAction",
          name: "SinglecardE",
          meta: {
            title: "单卡话机小号E用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/SmartTransCardAction",
          name: "SmartTransCard",
          meta: {
            title: "蓝猫智能卡用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/SmartLenveCardAction",
          name: "SmartLenveCardAction",
          meta: {
            title: "联想智能卡用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },

        {
          path: "/home/account/SmartPhoneCardAction",
          name: "SmartPhoneCardAction",
          meta: {
            title: "话机智能卡用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/CloudTrumpetCardAction",
          name: "CloudTrumpetCardAction",
          meta: {
            title: "云小号用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/account/AxSipAction",
          name: "AxSipAction",
          meta: {
            title: "话机可呼入SIP用户",
          },
          component: () =>
            import("../views/account/individual/index.vue"),
        },
        {
          path: "/home/telemarketing/VirtualQCAssistantAction",
          name: "VirtualQCAssistant",
          meta: {
            title: "虚商通信助手",
          },
          component: () =>
            import(
              "../views/businesssetup/telemarketing/VirtualQCAssistant.vue"
            ),
        },
        {
          path: "/home/system/iccidStopRecAction",
          name: " ",
          meta: {
            title: "SIM卡停复机",
          },
          component: () => import("../views/systemsettings/iccidStopRecAction"),
        },
        // 话单推送比对
        {
          path: "/home/simcard/comparePushAction",
          meta: {
            title: "话单推送比对",
          },
          name: "ComparePushAction",
          component: () => import("@/views/system/ComparePushAction"),
        },
        //推送话单比对
        // {
        //   path: "/home/pneumatic/pushBillComparison",
        //   name: "pushBillComparison",
        //   component: () =>
        //     import(
        //       "@/views/businesssetup/telemarketing/components/pushBillComparison/index"
        //     ),
        // },
        //自动比对记录
        {
          path: "/home/pneumatic/automaticComparisonrecord",
          name: "automaticComparisonrecord",
          component: () =>
            import(
              "@/views/businesssetup/telemarketing/components/pushBillComparison/components/automaticComparisonrecord.vue"
            ),
        },
        //手动比对详情
        {
          path: "/home/pneumatic/manualComparisonDetail",
          name: "manualComparisonDetail",
          component: () =>
            import(
              "@/views/businesssetup/telemarketing/components/pushBillComparison/components/manualComparisonDetail.vue"
            ),
        },
        //推送话单比对详情
        {
          path: "/home/pneumatic/automaticComparisonDetail",
          name: "automaticComparisonDetail",
          component: () =>
            import(
              "@/views/businesssetup/telemarketing/components/pushBillComparison/components/automaticComparisonDetail.vue"
            ),
        },
        // 通话详情
        {
          path: "/home/pneumatic/callDetails",
          name: "callDetails",
          component: () =>
            import(
              "../views/businesssetup/telemarketing/components/callDetails.vue"
            ),
        },
        // 远特平台ICCID对比
        {
          path: "/home/pneumatic/comparison",
          name: "comparison",
          component: () =>
            import(
              "../views/businesssetup/telemarketing/components/comparison.vue"
            ),
        },
        // 虚商通信话单比对
        {
          path: "/home/pneumatic/callOrderComparison",
          name: "callOrderComparison",
          component: () =>
            import(
              "../views/businesssetup/telemarketing/components/callOrderComparison.vue"
            ),
        },
        // 话单比对详情
        {
          path: "/home/pneumatic/comparisonDetail",
          name: "comparisonDetail",
          component: () =>
            import(
              "../views/businesssetup/telemarketing/components/comparisonDetail.vue"
            ),
        },
        //用户登录IP绑定
        {
          path: "/home/system/UserBindIpAction",
          name: "UserBindIpAction",
          meta: {
            title: "用户登录IP绑定",
          },
          component: () => import("../views/systemsettings/UserBindIp"),
        },
        //通用统计
        {
          path: "/home/system/CallNumberAction",
          name: "CallNumberAction",
          meta: {
            title: "通用统计",
          },
          component: () => import("@/views/system/CallNumberAction"),
        },
        //电话统计
        {
          path: "/home/system/CallStatisticsAction",
          name: "CallStatisticsAction",
          meta: {
            title: "电话统计",
          },
          component: () => import("@/views/system/CallStatisticsAction"),
        },
        //企业话务统计
        {
          path: "/home/system/EnterpriseTrafficStatisticsAction",
          name: "EnterpriseTrafficStatisticsAction",
          meta: {
            title: "企业话务统计",
          },
          component: () => import("@/views/system/EnterpriseTrafficStatistics"),
        },
      ],
    },
  ],
});

//解决反复点击路由报错
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  //     next()  放行    next('/login')  强制跳转
  const name = to.query.name;
  if (name) {
    window.sessionStorage.setItem("name", name);
  }
  const tokenStr = to.query.token || window.sessionStorage.getItem("token");
  if (!tokenStr) {
    if (to.path === "/login") return next();
    if (to.path === "/registered") return next();
    if (to.path === "/Forget") return next();
    if (to.path === "/retrievePassword") return next();
    if (to.path === "/resetPasswords") return next();
    if (to.path === "/succeedPasswords") return next();
    next("/login");
  } else {
    window.sessionStorage.setItem("token", tokenStr);
    next();
  }
});

export default router;
